import React, { ReactElement } from "react";

import classNames from "classnames";

import { IconChat } from "../icons/IconChat";
import { agentLauncherButtonCSS } from "./AgentLauncherButton.styles";
import { AgentLauncherButtonProps } from "./AgentLauncherButton.types";

export const AgentLauncherButton = ({
  className,
  isChatWindowOpen,
  agentName = "AGENT NAME",
  ...rest
}: AgentLauncherButtonProps): ReactElement => {
  return (
    <button
      className={classNames(
        agentLauncherButtonCSS,
        { active: isChatWindowOpen },
        className
      )}
      {...rest}
      type="button"
    >
      <IconChat gradient /> {agentName}
    </button>
  );
};
